/**
 * LeavesAndAbsencesView
 *
 * "Leaves & Absences" page: Congés (sub-view 0) and the arrêts de travail (sub-view 1). On
 * desktop the sub-views are picked from the sidebar group in MenuBar; on a phone the rail is
 * replaced by MobileMenu, which has no sub-items, so a tab bar is shown here.
 *
 * The arrêts sub-view is open to everyone, but what it shows depends on the `workStoppages`
 * scope: its holders (HR, Paie) get the company-wide suivi, everyone else their own arrêts.
 */
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Tabs, Tab } from "@mui/material";
import Langs from "../../app/lang/langs";
import { checkPermission } from "../../app/utils/helpers";
import { config } from "../../app/utils/config";
import { LeavesView } from "./LeavesView";
import WorkStoppagesView from "./WorkStoppagesView";
import MyWorkStoppagesView from "./MyWorkStoppagesView";

export const LEAVES_SUBVIEW = 0;
export const WORK_STOPPAGES_SUBVIEW = 1;

export default function LeavesAndAbsencesView() {
  const urlParams = useParams();
  const navigate = useNavigate();
  const isMobile = useSelector((state) => state.settings.isMobile);
  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds);
  // Subscribed so the view re-renders once permissions arrive.
  useSelector((state) => state.login.permissions);

  // Its own scope, not `leaves`: the suivi shows every collab's motif d'arrêt company-wide.
  // See permissions.md.
  const hasWorkStoppagesView = checkPermission(config.scopes.workStoppages, config.permissionTypes.view);
  const subView = Number(urlParams.subView) === WORK_STOPPAGES_SUBVIEW ? WORK_STOPPAGES_SUBVIEW : LEAVES_SUBVIEW;

  return (
    <div>
      {isMobile === 2 && (
        <Tabs
          value={subView}
          onChange={(_e, value) => navigate(`/leaves/${selectedTeamsIds[0]}/${value}`)}
          variant="fullWidth"
          sx={{
            minHeight: 40,
            "& .MuiTab-root": { minHeight: 40, textTransform: "none", fontWeight: 600 },
          }}
        >
          <Tab value={LEAVES_SUBVIEW} label={<Langs str="Leaves" />} />
          <Tab value={WORK_STOPPAGES_SUBVIEW} label={<Langs str="WORK_STOPPAGES" />} />
        </Tabs>
      )}
      {subView === LEAVES_SUBVIEW && <LeavesView />}
      {subView === WORK_STOPPAGES_SUBVIEW && (hasWorkStoppagesView ? <WorkStoppagesView /> : <MyWorkStoppagesView />)}
    </div>
  );
}
